import * as main from "../cjs/main.js";
export default main;
export const bankDataByBBAN = main.bankDataByBBAN;
export const bankDataByBLZ = main.bankDataByBLZ;
export const bankDataByIBAN = main.bankDataByIBAN;
export const isValidBIC = main.isValidBIC;